/* =====================
   TOAST NOTIFICATIONS
   ===================== */
(function () {
  var container;

  function getContainer() {
    if (!container) {
      container = document.createElement('div');
      container.id = 'toast-container';
      document.body.appendChild(container);
    }
    return container;
  }

  window.showToast = function (productName) {
    var c = getContainer();

    var toast = document.createElement('div');
    toast.className = 'toast slide-in-fade-bottom';
    toast.textContent = 'Produkt ' + productName + ' lades till i kundkorgen';

    c.appendChild(toast);

    var hideTimer = setTimeout(function () {
      toast.classList.remove('slide-in-fade-bottom');
      toast.classList.add('slide-out-fade-bottom');
      toast.addEventListener('animationend', function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, { once: true });
    }, 4000);

    toast.addEventListener('click', function () {
      clearTimeout(hideTimer);
      toast.classList.remove('slide-in-fade-bottom');
      toast.classList.add('slide-out-fade-bottom');
      toast.addEventListener('animationend', function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, { once: true });
    });
  };
})();
